var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefinanced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99024 8.43801C5.26046 8.43801 5.29424 8.47178 5.41247 8.67445L7.60802 12.7109H10.7325L8.48624 8.75889C8.30046 8.42112 8.19913 8.26912 8.06402 8.03267V7.99889C9.38135 7.54289 10.3947 6.39445 10.3947 4.60423C10.3947 2.59445 9.12802 0.888672 6.13869 0.888672H0.666687V12.7109H3.36891V8.43801H4.99024ZM3.36891 3.08423H5.80091C7.00002 3.08423 7.6418 3.70912 7.6418 4.67178C7.6418 5.61756 7.01691 6.24245 5.80091 6.24245H3.36891V3.08423Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinanced);
export default __webpack_public_path__ + "static/media/refinanced.7a8ae610828c672ecb3840d6435c66c7.svg";
export { ForwardRef as ReactComponent };